module.exports = __webpack_public_path__ + "img/menu-bim-active.28de45ac.svg";